import { createReducer, on } from '@ngrx/store';

import { HistoryBookingDetail } from '@user-history/entities/history-booking-detail';
import * as actions from '@abandoned-reservation/store/actions/abandoned-reservation.actions';

export const initial: HistoryBookingDetail = {} as HistoryBookingDetail;

export const abandonedReservationReducer = createReducer(
  initial,
  on(actions.fetchAbandonedReservationAction, () => initial),
  on(actions.fetchAbandonedReservationErrorAction, () => initial),
  on(actions.fetchAbandonedReservationSuccessAction, (state, { response }) => {
    return response ? response : state;
  }),
  on(actions.cancelAbandonedReservationSuccessAction, () => initial),
);
